import { Popover } from "@base-ui/react/popover"
import classNames from "classnames"
import PropTypes from "prop-types"
import React, { useState } from "react"

const BasePopover = ({
  label,
  children,
  side = "bottom",
  align = "start",
  width,
}) => {
  const [open, setOpen] = useState(false)

  return (
    <Popover.Root open={open} onOpenChange={setOpen}>
      <Popover.Trigger className="btn btn-secondary w-full whitespace-nowrap">
        <span className="block w-11/12 truncate">{label}</span>
        <i
          className={classNames("icon ml-2 shrink-0 text-xxxs", {
            "icon-sf-chevron-up": open,
            "icon-sf-chevron-down": !open,
          })}
        />
      </Popover.Trigger>
      <Popover.Portal>
        <Popover.Positioner
          side={side}
          align={align}
          sideOffset={4}
          className="z-50"
        >
          <Popover.Popup
            className="rounded border bg-white shadow-lg ring-1 ring-black ring-opacity-5"
            style={width ? { width } : undefined}
            initialFocus={false}
          >
            {children}
          </Popover.Popup>
        </Popover.Positioner>
      </Popover.Portal>
    </Popover.Root>
  )
}

BasePopover.propTypes = {
  label: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  side: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  align: PropTypes.oneOf(["start", "center", "end"]),
  width: PropTypes.string,
}

export default BasePopover
